module.exports = __webpack_public_path__ + "media/images/iconSearch__okGreen-927bfb89311c3327820c163e59e6dc4a.png";